import { StateContext } from './state';
export enum ActionType {
  DATA = 'update data',
}
export type Action = { type: ActionType.DATA; payload };
export const reducer = (state: StateContext, action: Action): { data } => {
  switch (action.type) {
    case ActionType.DATA:
      return { ...state, data: action.payload };
    default:
      throw new Error('Not among actions');
  }
};
